module.exports = __webpack_public_path__ + "static/aloopmodals-2b6783952b15782e41b9a36bb4c692d3.png";